<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    红花山站<br>
站点介绍<br>
红花山站位于别墅路与兴发路交叉口以西，沿别墅路呈东西向布置。东北侧为公明中英文学校，西北侧为“雍景城”高端住宅区，东南侧为“宏发美域”住宅群，西南侧为公明体育中心。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:34	23:14	6号线	3分24秒	6分20秒<br>
松岗	06:12	23:57	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:34	23:14	6号线	4分45秒	6分钟<br>
松岗	06:12	23:57	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:34	00:14	6号线	4分45秒	6分钟<br>
松岗	06:12	00:57	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
公明中英文学校<br><br>
B出入口:<br>
宏发雍景城<br><br>
C出入口:<br>
宏发雍景城<br><br>
D出入口:<br>
光明区红花山体育中心<br><br>
E出入口:<br>
宏发美域小区<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 红花山地铁站<br>
B720，M243，K578，高峰专线132<br><br>
B1出入口:<br>
公交站名： 红花山地铁站<br>
B720，高快巴士30，高峰专线132<br><br>
B2出入口:<br>
公交站名： 红花山地铁站<br>
B720，M243，K578，高峰专线132<br><br>
C出入口:<br>
公交站名： 红花山地铁站<br>
B720，高快巴士30，高峰专线132<br><br>
D出入口:<br>
公交站名： 红花山地铁站<br>
M243，高峰专线132<br><br>
E1出入口:<br>
公交站名： 红花山地铁站<br>
M243，高峰专线132<br><br>
E2出入口:<br>
公交站名： 红花山地铁站<br>
M243，高峰专线132<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>